import { render } from "./QuizDefinitionImage.vue?vue&type=template&id=91f1401e&scoped=true"
import script from "./QuizDefinitionImage.vue?vue&type=script&lang=js"
export * from "./QuizDefinitionImage.vue?vue&type=script&lang=js"

import "./QuizDefinitionImage.vue?vue&type=style&index=0&id=91f1401e&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f1401e"]])

export default __exports__